<template>
  <a-config-provider
    :theme="{
      token: {
        colorPrimary: '#00b96b',
        fontFamily: 'Open Sans',
        fontSize: 12,
        borderRadius: 10,
        colorBorder: '#A6A6A6',
      },
    }"
  >
  </a-config-provider>
  <router-view />
  <component :is="contextHolder" />
</template>

<script setup lang="ts">
import { useModalsStore } from "@/stores/modals/modalsStore";

const modalsStore = useModalsStore();
const { contextHolder } = modalsStore;
</script>

<style lang="scss" scoped></style>
